module.exports = __webpack_public_path__ + "img/close.d74688d3.png";